import { CONTRACTORS } from '../actions/contractorsActions';

// Contractor:
//      id: number
//      name: string
//      nif: string
//      domain: string
//      api_base_url: string
//      api_username: string
//      api_password: string
//      show_create_task_window: boolean
//      disabled: boolean
//      script_worker_states: string
//      company: CompanyBasic
//
// CompanyBasic:
//      id: number
//      name: string
//      nif: string

const INITIAL_STATE = {
    contractors: [],
    contractorsLoading: false,
    contractorsPagination: null,
    contractor: null,
    contractorLoading: false,
    contractorSearch: null,
    contractorsSearchLoading: false,
    contractorsSearchError: null,
};

export default (state = INITIAL_STATE, action) => {
    switch ( action.type ) {
        case CONTRACTORS.FETCH_CONTRACTORS_SUCCEED:
            return {
                ...state,
                contractors: action.payload.data,
                contractorsPagination: action.payload.pagination,
            };
        case CONTRACTORS.FETCH_CONTRACTORS_LOADING:
            return {
                ...state,
                contractorsLoading: action.payload,
            };
        case CONTRACTORS.FETCH_CONTRACTORS_BASIC_SUCCEED:
            return {
                ...state,
                contractors: action.payload.data,
            };
        case CONTRACTORS.FETCH_CONTRACTORS_BASIC_LOADING:
            return {
                ...state,
                contractorsLoading: action.payload,
            };
        case CONTRACTORS.FETCH_CONTRACTOR_SUCCEED:
            return {
                ...state,
                contractor: action.payload.data,
            };
        case CONTRACTORS.FETCH_CONTRACTOR_LOADING:
            return {
                ...state,
                contractorLoading: action.payload,
            };
        case CONTRACTORS.CONTRACTORS_SEARCH_LOADING:
            return {
                ...state,
                contractorsSearchLoading: action.payload,
            };
        case CONTRACTORS.CONTRACTORS_SEARCH_UPDATE:
            return {
                ...state,
                contractorSearch: action.payload,
            };
        case CONTRACTORS.CONTRACTOR_CREATE_FROM_COMPANY_CONFIRM_MODAL_DISPLAY:
            return {
                ...state,
                displayDialog: action.payload.displayDialog,
                contractorSave: action.payload.contractorSave,
            };
        case CONTRACTORS.CREATE_CONTRACTOR_LOADING:
            return {
                ...state,
                createContractorLoading: action.payload,
            };
        case CONTRACTORS.CONTRACTORS_SHOW_FIELDS:
            return {
                ...state,
                showFields: action.payload,
            };
        case CONTRACTORS.FETCH_CONTRACTOR_CURRENT_SUCCEED:
        case CONTRACTORS.FETCH_CONTRACTOR_CURRENT_LOADING:
        case CONTRACTORS.CREATE_CONTRACTOR_SUCCEED:
        case CONTRACTORS.UPDATE_CONTRACTOR_SUCCEED:
        case CONTRACTORS.UPDATE_CONTRACTOR_LOADING:
        case CONTRACTORS.DELETE_CONTRACTOR_SUCCEED:
        case CONTRACTORS.DELETE_CONTRACTOR_LOADING:
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/app/contractors/reducers/ContractorsReducer.js